export default __webpack_public_path__ + "static/media/sign_up_header.70845be4.png";